import { TopMenuContent } from 'iebt-zing-storybook/dist/pages/Layout/TeiaPageTop'
import { ROUTES } from '@zing/shared/constants'
import { getHubRoute } from '@zing/shared/handlers'
import { IUser } from '@zing/shared/user/contracts/iUser'
import React from 'react'
import { getCredLocalStorage } from '@zing/shared/auth/credLocalStorage'

class TopMenuBuiderFactory {
  build(): TopMenuBuider {
    return new TopMenuBuider()
  }
}
export interface TopMenuActions {
  configAction?: () => void
  logoutAction: () => void
}

class TopMenuBuider {
  build(menuActionsBuild: TopMenuActions, user: IUser): TopMenuContent {
    const cityHallName = getCredLocalStorage()?.cityHallInfo?.Name

    const menuItems: TopMenuContent = {
      userSection: {
        avatar: user.avatar,
        name: user.name,
        company: cityHallName?.trim()
        ? cityHallName
        : user.company.name,
        logoutAction: () => {
          menuActionsBuild.logoutAction()
        }
      }
    }
    return menuItems
  }
}

const factory = new TopMenuBuiderFactory()
export const topMenuBuider = factory.build()
